import {
    ADD_SMS_TEMPLATE,
    GET_SMS_TEMPLATE,
    EDIT_SMS_TEMPLATE,
    ALL_SMS_TEMPLATE
  } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  data: null,
}

const SMSTemplate = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SMS_TEMPLATE:
    case GET_SMS_TEMPLATE:
      state = {
        ...state,
        loading: true,
      }
      break
    case ALL_SMS_TEMPLATE:
      state = {
        ...state,
        loading: false,
        data: action.payload.data,
      }
      break
    case EDIT_SMS_TEMPLATE:
      state = {
        ...state,
        loading: false,
      }
      break
    default:
      break
  }
  return state
}

export default SMSTemplate